<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
import { computed, inject } from 'vue'

const { potential, version, mapStyle } = useDetailsReport()
const { application, pages, screen, global } = inject('Shared')

const splitAddress = computed(() => {
  const address = potential.value.buildings[0].address
  const index = address.match(/\d{4}/).index - 1
  return [address.slice(0, index - 1), address.slice(index + 1)]
})
</script>

<template lang="pug">
.potential-map--container
  #potentialPageMap(:style="`height: 470px; width: 100%;`").box
    .popupBoxContainer
      .mapPopupBox
        .addressLabel {{application === 'WEB_APP' ? 'Raumpioniere-' : ''}}Potenzialanalyse
        .addressRow
          .svg(style="width: 36px" v-if="application === 'WEB_APP' && version === 1")
            svg(width='36' height='35' viewBox='0 0 36 35' fill='none' xmlns='http://www.w3.org/2000/svg')
              path(d='M17.1156 0.676341C17.4908 -0.0348052 18.5092 -0.0348076 18.8844 0.676339L23.8835 10.1513C24.0282 10.4256 24.2919 10.6172 24.5975 10.6701L35.1535 12.4965C35.9458 12.6336 36.2605 13.6022 35.7001 14.1788L28.2337 21.8612C28.0176 22.0835 27.9168 22.3936 27.961 22.7005L29.4859 33.3043C29.6004 34.1002 28.7764 34.6988 28.0548 34.344L18.4412 29.617C18.163 29.4801 17.837 29.4801 17.5588 29.617L7.94516 34.344C7.22361 34.6988 6.39964 34.1002 6.51409 33.3043L8.03902 22.7005C8.08316 22.3936 7.98242 22.0835 7.76631 21.8612L0.299856 14.1788C-0.26054 13.6022 0.0541873 12.6336 0.846473 12.4965L11.4025 10.6701C11.7081 10.6172 11.9718 10.4256 12.1165 10.1513L17.1156 0.676341Z' fill='#5FEFC0')
          .address
            div {{ splitAddress[0] }}
            div {{ splitAddress[1] }}
    .mapStyleContainer
      .mapStyleButton(:class="mapStyle === 'LIGHT' ? 'leftButtonSelected' : 'leftButtonUnSelected'" @click="mapStyle = 'LIGHT'") Karte
      .mapStyleButton(:class="mapStyle === 'SATELLITE' ? 'rightButtonSelected' : 'rightButtonUnSelected'" @click="mapStyle = 'SATELLITE'") Satellit
</template>

<style scoped lang="sass">
.potential-map--container
  @media screen and (min-width: 1440px)
    margin-bottom: 40px
    width: calc(50% - 16px)
  @media screen and (max-width: 1440px)
    margin-bottom: 20px
    width: 100%
  .leftButtonSelected
    background: v-bind('pages.detailReport.mapboxViewBtnSelectedBackgroundColor')
    color: v-bind('pages.detailReport.mapboxViewBtnSelectedColor')
    border-top-left-radius: v-bind('global.buttonBorderRadius')
    border-bottom-left-radius: v-bind('global.buttonBorderRadius')
  .leftButtonUnSelected
    border-top-left-radius: v-bind('global.buttonBorderRadius')
    border-bottom-left-radius: v-bind('global.buttonBorderRadius')
    background: v-bind('pages.detailReport.mapboxViewBtnUnselectedBackgroundColor')
    color: v-bind('pages.detailReport.mapboxViewBtnUnselectedColor')
    border-color: v-bind('pages.detailReport.mapboxViewBtnUnselectedColor')
    border-style: solid
    border-width: 1px
    box-sizing: border-box
    box-shadow: 0px 6px 16px rgba(0, 123, 255, 0.12)
  .rightButtonSelected
    background: v-bind('pages.detailReport.mapboxViewBtnSelectedBackgroundColor')
    color: v-bind('pages.detailReport.mapboxViewBtnSelectedColor')
    box-sizing: border-box
    box-shadow: 0px 6px 16px rgba(0, 123, 255, 0.12)
    border-top-right-radius: v-bind('global.buttonBorderRadius')
    border-bottom-right-radius: v-bind('global.buttonBorderRadius')
  .rightButtonUnSelected
    background: v-bind('pages.detailReport.mapboxViewBtnUnselectedBackgroundColor')
    color: v-bind('pages.detailReport.mapboxViewBtnUnselectedColor')
    border-color: v-bind('pages.detailReport.mapboxViewBtnUnselectedColor')
    border-style: solid
    border-width: 1px
    box-sizing: border-box
    box-shadow: 0px 6px 16px rgba(0, 123, 255, 0.12)
    border-top-right-radius: v-bind('global.buttonBorderRadius')
    border-bottom-right-radius: v-bind('global.buttonBorderRadius')
  .popupBoxContainer
    position: absolute
    top: 16px
    left: 0px
    width: 100%
    z-index: 10
    display: flex
    justify-content: center
    .mapPopupBox
      background: white
      border-radius: 10px
      border: 1px solid #D9D9D9
      box-sizing: border-box
      backdrop-filter: blur(12px)
      -webkit-backdrop-filter: blur(12px)
      padding: 16px
      width: 90%
      .addressRow
        display: flex
        flex-direction: row
        align-content: center
      .address
        font-style: normal
        font-weight: bold
        font-size: v-bind('pages.detailReport.addressFontSize')
        line-height: 130%
        color: v-bind('pages.detailReport.addressColor')
        flex: 1
      .svg
        margin-right: 10px
      .addressLabel
        font-style: normal
        font-weight: bold
        font-size: 15px
        line-height: 154%
        color: #626C85
  .box
    position: relative
    background: rgba(255, 255, 255, 0.9)
    border: 1px solid #D9D9D9
    box-sizing: border-box
    box-shadow: 0px 15px 30px rgba(166, 166, 166, 0.25)
    border-radius: 10px
    @media screen and (min-width: 1440px)
      padding: 30px 40px
      height: 470px
    @media screen and (max-width: 1440px)
      padding: 15px 20px 15px 20px
    .mapStyleContainer
      position: absolute
      bottom: 30px
      right: 30px
      z-index: 10
      display: flex
      flex-direction: row
      .mapStyleButton
        cursor: pointer
        display: flex
        justify-content: center
        align-content: center
        width: 88px
        padding: 5px 0
        font-size: 14px
        font-weight: bold
        line-height: 130%
</style>
